import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ConfirmDialogService } from '../../core/components/confirm-dialog/confirm-dialog.service';

@Injectable()
export class HubSpotSandboxService {
    // useSandbox only ever leaves sandbox through the confirm dialog; checked mirrors the box.
    useSandbox = true;
    checked = true;

    // The dialog is not modal, so a stale callback must not outlive the click that opened it.
    private toggleGeneration = 0;

    constructor(private confirmDialogService: ConfirmDialogService) { }

    toggle(checked: boolean) {
        const generation = ++this.toggleGeneration;
        this.checked = checked;

        if (checked) {
            this.useSandbox = true;
            return;
        }

        this.confirmDialogService.showConfirm(
            'Switching to the production HubSpot token points every HubSpot button on this page at live production data. Continue?',
            () => {
                if (generation === this.toggleGeneration) {
                    this.useSandbox = false;
                }
            },
            () => {
                if (generation === this.toggleGeneration) {
                    this.checked = true;
                    this.useSandbox = true;
                }
            }
        );
    }

    withSandbox(params: HttpParams = new HttpParams()): HttpParams {
        return params.set('sandbox', String(this.useSandbox));
    }

    portal(): string {
        return this.useSandbox ? 'sandbox' : 'production';
    }

    // Reads as the destination in a confirm prompt, shouting only when it is the live portal.
    target(): string {
        return this.useSandbox ? 'the HubSpot sandbox portal' : 'PRODUCTION HubSpot';
    }
}



// WEBPACK FOOTER //
// ./src/app/developer/services/hubspot-sandbox.service.ts